import { memo } from "react";
import { useTranslation } from "react-i18next";
import { Badge } from "@/components/ui/badge";

interface CardRequireBadgeProps {
  required: boolean;
}

export const CardRequireBadge = memo(({ required }: CardRequireBadgeProps) => {
  const { t } = useTranslation();

  return (
    <Badge variant={required ? "default" : "secondary"}>
      {required
        ? t("contractorCards.values.required")
        : t("contractorCards.values.optional")}
    </Badge>
  );
});
